import Reveal from "@/components/base/Reveal";
import { insiderQuotes } from "@/mocks/home";

export default function InsiderSection() {
  return (
    <section id="insider" className="w-full bg-secondary-950 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1400px] px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="text-xs font-medium tracking-[0.24em] text-accent-400">
                INSIDER REVEALS
              </span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                知情人透露
              </h2>
            </div>
            <p className="max-w-xl text-sm leading-relaxed text-secondary-300">
              来自知情人的三次补充说明，指向早期版本与现流传版本之间的差异，这几句话往往最关键。
            </p>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {insiderQuotes.map((item, index) => (
            <Reveal key={item.source} delay={80 * index}>
              <figure className="flex h-full flex-col rounded-lg border border-secondary-800 bg-secondary-900/70 p-6">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500/15 text-lg text-accent-400">
                  <i className="ri-double-quotes-l" />
                </span>
                <blockquote className="mt-4 flex-1 font-heading text-base leading-relaxed text-background-100">
                  {item.quote}
                </blockquote>
                <figcaption className="mt-5 flex items-center justify-between border-t border-secondary-800 pt-4 text-xs">
                  <span className="text-secondary-300">{item.source}</span>
                  <span className="rounded-full bg-secondary-800 px-2.5 py-0.5 text-secondary-300">
                    {item.time}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}